import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HeaderBeihilfeLegacyInterceptor } from '@ebeihilfe/core';

import { EbeihilfeEinreichungComponent } from './components';
import { EinreichungDirective } from './directives';
import {
  CanSendAntragPipe,
  CurrentBelegSizePipe,
  CurrentSizeInBytePipe,
  HasAllMandatoryPagesPipe,
  HasPagesPipe,
  MaxSizeExceededPipe,
  PercentageOfMaxSizePipe,
} from './pipes';

const PIPES = [
  MaxSizeExceededPipe,
  CurrentSizeInBytePipe,
  CanSendAntragPipe,
  CurrentBelegSizePipe,
  HasPagesPipe,
  PercentageOfMaxSizePipe,
  HasAllMandatoryPagesPipe,
];

@NgModule({
  imports: [...PIPES, EinreichungDirective, EbeihilfeEinreichungComponent],
  exports: [EbeihilfeEinreichungComponent, ...PIPES],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderBeihilfeLegacyInterceptor,
      multi: true,
    },
  ],
})
export class OldCoreEinreichungModule {}
